var map = {
	"./prism-abap.js": 66691,
	"./prism-abap.min.js": 12477,
	"./prism-abnf.js": 71694,
	"./prism-abnf.min.js": 86240,
	"./prism-actionscript.js": 75500,
	"./prism-actionscript.min.js": 18142,
	"./prism-ada.js": 65193,
	"./prism-ada.min.js": 35915,
	"./prism-agda.js": 84126,
	"./prism-agda.min.js": 27792,
	"./prism-al.js": 55392,
	"./prism-al.min.js": 69882,
	"./prism-antlr4.js": 17876,
	"./prism-antlr4.min.js": 1958,
	"./prism-apacheconf.js": 22253,
	"./prism-apacheconf.min.js": 52791,
	"./prism-apex.js": 73269,
	"./prism-apex.min.js": 33535,
	"./prism-apl.js": 99882,
	"./prism-apl.min.js": 89220,
	"./prism-applescript.js": 99050,
	"./prism-applescript.min.js": 12836,
	"./prism-aql.js": 45383,
	"./prism-aql.min.js": 60201,
	"./prism-arduino.js": 43969,
	"./prism-arduino.min.js": 16323,
	"./prism-arff.js": 22118,
	"./prism-arff.min.js": 26008,
	"./prism-armasm.js": 2228,
	"./prism-armasm.min.js": 48358,
	"./prism-arturo.js": 83678,
	"./prism-arturo.min.js": 20144,
	"./prism-asciidoc.js": 61710,
	"./prism-asciidoc.min.js": 76896,
	"./prism-asm6502.js": 39517,
	"./prism-asm6502.min.js": 66183,
	"./prism-asmatmel.js": 55689,
	"./prism-asmatmel.min.js": 38891,
	"./prism-aspnet.js": 79970,
	"./prism-aspnet.min.js": 56412,
	"./prism-autohotkey.js": 26404,
	"./prism-autohotkey.min.js": 13686,
	"./prism-autoit.js": 63003,
	"./prism-autoit.min.js": 22101,
	"./prism-avisynth.js": 86241,
	"./prism-avisynth.min.js": 68835,
	"./prism-avro-idl.js": 17851,
	"./prism-avro-idl.min.js": 11765,
	"./prism-awk.js": 66892,
	"./prism-awk.min.js": 71934,
	"./prism-bash.js": 52059,
	"./prism-bash.min.js": 85,
	"./prism-basic.js": 61515,
	"./prism-basic.min.js": 1061,
	"./prism-batch.js": 51165,
	"./prism-batch.min.js": 58439,
	"./prism-bbcode.js": 4804,
	"./prism-bbcode.min.js": 41110,
	"./prism-bbj.js": 68111,
	"./prism-bbj.min.js": 15953,
	"./prism-bicep.js": 22170,
	"./prism-bicep.min.js": 77524,
	"./prism-birb.js": 94308,
	"./prism-birb.min.js": 10614,
	"./prism-bison.js": 2030,
	"./prism-bison.min.js": 10528,
	"./prism-bnf.js": 49615,
	"./prism-bnf.min.js": 69489,
	"./prism-bqn.js": 61016,
	"./prism-bqn.min.js": 29266,
	"./prism-brainfuck.js": 93466,
	"./prism-brainfuck.min.js": 7188,
	"./prism-brightscript.js": 90038,
	"./prism-brightscript.min.js": 53800,
	"./prism-bro.js": 28724,
	"./prism-bro.min.js": 18662,
	"./prism-bsl.js": 10816,
	"./prism-bsl.min.js": 33562,
	"./prism-c.js": 20732,
	"./prism-c.min.js": 77998,
	"./prism-cfscript.js": 58203,
	"./prism-cfscript.min.js": 65749,
	"./prism-chaiscript.js": 24023,
	"./prism-chaiscript.min.js": 48345,
	"./prism-cil.js": 3141,
	"./prism-cil.min.js": 83183,
	"./prism-cilkc.js": 13543,
	"./prism-cilkc.min.js": 91337,
	"./prism-cilkcpp.js": 967,
	"./prism-cilkcpp.min.js": 9097,
	"./prism-clike.js": 80627,
	"./prism-clike.min.js": 73965,
	"./prism-clojure.js": 29113,
	"./prism-clojure.min.js": 74139,
	"./prism-cmake.js": 62766,
	"./prism-cmake.min.js": 16896,
	"./prism-cobol.js": 28702,
	"./prism-cobol.min.js": 63568,
	"./prism-coffeescript.js": 24082,
	"./prism-coffeescript.min.js": 18348,
	"./prism-concurnas.js": 20601,
	"./prism-concurnas.min.js": 4251,
	"./prism-cooklang.js": 90729,
	"./prism-cooklang.min.js": 72043,
	"./prism-coq.js": 87392,
	"./prism-coq.min.js": 3290,
	"./prism-core.js": 43498,
	"./prism-core.min.js": 14948,
	"./prism-cpp.js": 39476,
	"./prism-cpp.min.js": 90086,
	"./prism-crystal.js": 29415,
	"./prism-crystal.min.js": 67529,
	"./prism-csharp.js": 81422,
	"./prism-csharp.min.js": 22944,
	"./prism-cshtml.js": 64090,
	"./prism-cshtml.min.js": 42516,
	"./prism-csp.js": 21651,
	"./prism-csp.min.js": 20237,
	"./prism-css-extras.js": 24884,
	"./prism-css-extras.min.js": 39014,
	"./prism-css.js": 2006,
	"./prism-css.min.js": 88872,
	"./prism-csv.js": 30745,
	"./prism-csv.min.js": 84763,
	"./prism-cue.js": 35530,
	"./prism-cue.min.js": 90756,
	"./prism-cypher.js": 47502,
	"./prism-cypher.min.js": 46080,
	"./prism-d.js": 52841,
	"./prism-d.min.js": 29227,
	"./prism-dart.js": 4816,
	"./prism-dart.min.js": 73226,
	"./prism-dataweave.js": 16343,
	"./prism-dataweave.min.js": 81337,
	"./prism-dax.js": 44956,
	"./prism-dax.min.js": 8750,
	"./prism-dhall.js": 55490,
	"./prism-dhall.min.js": 87484,
	"./prism-diff.js": 20038,
	"./prism-diff.min.js": 29688,
	"./prism-django.js": 91802,
	"./prism-django.min.js": 52788,
	"./prism-dns-zone-file.js": 99952,
	"./prism-dns-zone-file.min.js": 7530,
	"./prism-docker.js": 7333,
	"./prism-docker.min.js": 34351,
	"./prism-dot.js": 73030,
	"./prism-dot.min.js": 96344,
	"./prism-ebnf.js": 25354,
	"./prism-ebnf.min.js": 98052,
	"./prism-editorconfig.js": 8670,
	"./prism-editorconfig.min.js": 99600,
	"./prism-eiffel.js": 46342,
	"./prism-eiffel.min.js": 21816,
	"./prism-ejs.js": 56497,
	"./prism-ejs.min.js": 99571,
	"./prism-elixir.js": 19134,
	"./prism-elixir.min.js": 66704,
	"./prism-elm.js": 90345,
	"./prism-elm.min.js": 72619,
	"./prism-erb.js": 17866,
	"./prism-erb.min.js": 1732,
	"./prism-erlang.js": 83114,
	"./prism-erlang.min.js": 53508,
	"./prism-etlua.js": 77268,
	"./prism-etlua.min.js": 12038,
	"./prism-excel-formula.js": 14185,
	"./prism-excel-formula.min.js": 19723,
	"./prism-factor.js": 6842,
	"./prism-factor.min.js": 88148,
	"./prism-false.js": 12646,
	"./prism-false.min.js": 87992,
	"./prism-firestore-security-rules.js": 26109,
	"./prism-firestore-security-rules.min.js": 79751,
	"./prism-flow.js": 61613,
	"./prism-flow.min.js": 89111,
	"./prism-fortran.js": 32255,
	"./prism-fortran.min.js": 19329,
	"./prism-fsharp.js": 19995,
	"./prism-fsharp.min.js": 46549,
	"./prism-ftl.js": 81719,
	"./prism-ftl.min.js": 11641,
	"./prism-gap.js": 96957,
	"./prism-gap.min.js": 33735,
	"./prism-gcode.js": 29949,
	"./prism-gcode.min.js": 32039,
	"./prism-gdscript.js": 11821,
	"./prism-gdscript.min.js": 9431,
	"./prism-gedcom.js": 17936,
	"./prism-gedcom.min.js": 28778,
	"./prism-gettext.js": 18994,
	"./prism-gettext.min.js": 61772,
	"./prism-gherkin.js": 37015,
	"./prism-gherkin.min.js": 22297,
	"./prism-git.js": 66761,
	"./prism-git.min.js": 66507,
	"./prism-glsl.js": 37013,
	"./prism-glsl.min.js": 58015,
	"./prism-gml.js": 31277,
	"./prism-gml.min.js": 61783,
	"./prism-gn.js": 55884,
	"./prism-gn.min.js": 43998,
	"./prism-go-module.js": 30140,
	"./prism-go-module.min.js": 60302,
	"./prism-go.js": 61107,
	"./prism-go.min.js": 365,
	"./prism-gradle.js": 14114,
	"./prism-gradle.min.js": 24412,
	"./prism-graphql.js": 65528,
	"./prism-graphql.min.js": 13938,
	"./prism-groovy.js": 40851,
	"./prism-groovy.min.js": 7725,
	"./prism-haml.js": 79103,
	"./prism-haml.min.js": 51393,
	"./prism-handlebars.js": 12845,
	"./prism-handlebars.min.js": 57303,
	"./prism-haskell.js": 61913,
	"./prism-haskell.min.js": 83323,
	"./prism-haxe.js": 71277,
	"./prism-haxe.min.js": 67415,
	"./prism-hcl.js": 35710,
	"./prism-hcl.min.js": 91696,
	"./prism-hlsl.js": 74358,
	"./prism-hlsl.min.js": 29448,
	"./prism-hoon.js": 68429,
	"./prism-hoon.min.js": 90135,
	"./prism-hpkp.js": 98070,
	"./prism-hpkp.min.js": 56648,
	"./prism-hsts.js": 46045,
	"./prism-hsts.min.js": 62791,
	"./prism-http.js": 69697,
	"./prism-http.min.js": 90979,
	"./prism-ichigojam.js": 78490,
	"./prism-ichigojam.min.js": 25876,
	"./prism-icon.js": 32320,
	"./prism-icon.min.js": 88058,
	"./prism-icu-message-format.js": 46878,
	"./prism-icu-message-format.min.js": 39696,
	"./prism-idris.js": 24836,
	"./prism-idris.min.js": 66390,
	"./prism-iecst.js": 5297,
	"./prism-iecst.min.js": 87507,
	"./prism-ignore.js": 36079,
	"./prism-ignore.min.js": 33457,
	"./prism-inform7.js": 79403,
	"./prism-inform7.min.js": 85125,
	"./prism-ini.js": 19383,
	"./prism-ini.min.js": 97305,
	"./prism-io.js": 34017,
	"./prism-io.min.js": 13091,
	"./prism-j.js": 42795,
	"./prism-j.min.js": 33669,
	"./prism-java.js": 24569,
	"./prism-java.min.js": 40379,
	"./prism-javadoc.js": 60071,
	"./prism-javadoc.min.js": 42633,
	"./prism-javadoclike.js": 37856,
	"./prism-javadoclike.min.js": 59770,
	"./prism-javascript.js": 63206,
	"./prism-javascript.min.js": 29560,
	"./prism-javastacktrace.js": 32496,
	"./prism-javastacktrace.min.js": 72106,
	"./prism-jexl.js": 80988,
	"./prism-jexl.min.js": 57934,
	"./prism-jolie.js": 11126,
	"./prism-jolie.min.js": 63784,
	"./prism-jq.js": 51476,
	"./prism-jq.min.js": 90438,
	"./prism-js-extras.js": 3788,
	"./prism-js-extras.min.js": 76222,
	"./prism-js-templates.js": 27672,
	"./prism-js-templates.min.js": 30834,
	"./prism-jsdoc.js": 74214,
	"./prism-jsdoc.min.js": 11672,
	"./prism-json.js": 49399,
	"./prism-json.min.js": 62233,
	"./prism-json5.js": 84260,
	"./prism-json5.min.js": 79542,
	"./prism-jsonp.js": 1935,
	"./prism-jsonp.min.js": 91249,
	"./prism-jsstacktrace.js": 19251,
	"./prism-jsstacktrace.min.js": 56813,
	"./prism-jsx.js": 43028,
	"./prism-jsx.min.js": 73606,
	"./prism-julia.js": 24404,
	"./prism-julia.min.js": 39206,
	"./prism-keepalived.js": 20415,
	"./prism-keepalived.min.js": 60449,
	"./prism-keyman.js": 54164,
	"./prism-keyman.min.js": 63430,
	"./prism-kotlin.js": 33804,
	"./prism-kotlin.min.js": 43166,
	"./prism-kumir.js": 82041,
	"./prism-kumir.min.js": 12763,
	"./prism-kusto.js": 78053,
	"./prism-kusto.min.js": 1615,
	"./prism-latex.js": 60057,
	"./prism-latex.min.js": 79355,
	"./prism-latte.js": 74983,
	"./prism-latte.min.js": 617,
	"./prism-less.js": 35908,
	"./prism-less.min.js": 30870,
	"./prism-lilypond.js": 19246,
	"./prism-lilypond.min.js": 69824,
	"./prism-linker-script.js": 60684,
	"./prism-linker-script.min.js": 25662,
	"./prism-liquid.js": 46577,
	"./prism-liquid.min.js": 68531,
	"./prism-lisp.js": 68945,
	"./prism-lisp.min.js": 86451,
	"./prism-livescript.js": 56228,
	"./prism-livescript.min.js": 15766,
	"./prism-llvm.js": 55356,
	"./prism-llvm.min.js": 19854,
	"./prism-log.js": 47627,
	"./prism-log.min.js": 57413,
	"./prism-lolcode.js": 40995,
	"./prism-lolcode.min.js": 80829,
	"./prism-lua.js": 16399,
	"./prism-lua.min.js": 24305,
	"./prism-magma.js": 13320,
	"./prism-magma.min.js": 27938,
	"./prism-makefile.js": 16605,
	"./prism-makefile.min.js": 84807,
	"./prism-markdown.js": 67768,
	"./prism-markdown.min.js": 29106,
	"./prism-markup-templating.js": 34427,
	"./prism-markup-templating.min.js": 42869,
	"./prism-markup.js": 32093,
	"./prism-markup.min.js": 2439,
	"./prism-mata.js": 80348,
	"./prism-mata.min.js": 32558,
	"./prism-matlab.js": 97608,
	"./prism-matlab.min.js": 70434,
	"./prism-maxscript.js": 24800,
	"./prism-maxscript.min.js": 26234,
	"./prism-mel.js": 12615,
	"./prism-mel.min.js": 98409,
	"./prism-mermaid.js": 92378,
	"./prism-mermaid.min.js": 10516,
	"./prism-metafont.js": 99221,
	"./prism-metafont.min.js": 11583,
	"./prism-mizar.js": 97694,
	"./prism-mizar.min.js": 17168,
	"./prism-mongodb.js": 67319,
	"./prism-mongodb.min.js": 92953,
	"./prism-monkey.js": 17864,
	"./prism-monkey.min.js": 91266,
	"./prism-moonscript.js": 16219,
	"./prism-moonscript.min.js": 74645,
	"./prism-n1ql.js": 82505,
	"./prism-n1ql.min.js": 36683,
	"./prism-n4js.js": 18632,
	"./prism-n4js.min.js": 19554,
	"./prism-nand2tetris-hdl.js": 39682,
	"./prism-nand2tetris-hdl.min.js": 62940,
	"./prism-naniscript.js": 93810,
	"./prism-naniscript.min.js": 60108,
	"./prism-nasm.js": 90532,
	"./prism-nasm.min.js": 44374,
	"./prism-neon.js": 49101,
	"./prism-neon.min.js": 54295,
	"./prism-nevod.js": 50007,
	"./prism-nevod.min.js": 24505,
	"./prism-nginx.js": 2085,
	"./prism-nginx.min.js": 7119,
	"./prism-nim.js": 34781,
	"./prism-nim.min.js": 87015,
	"./prism-nix.js": 96770,
	"./prism-nix.min.js": 69724,
	"./prism-nsis.js": 33610,
	"./prism-nsis.min.js": 95524,
	"./prism-objectivec.js": 97593,
	"./prism-objectivec.min.js": 34459,
	"./prism-ocaml.js": 73477,
	"./prism-ocaml.min.js": 9839,
	"./prism-odin.js": 41729,
	"./prism-odin.min.js": 68771,
	"./prism-opencl.js": 70458,
	"./prism-opencl.min.js": 18452,
	"./prism-openqasm.js": 9959,
	"./prism-openqasm.min.js": 51785,
	"./prism-oz.js": 10904,
	"./prism-oz.min.js": 92178,
	"./prism-parigp.js": 64340,
	"./prism-parigp.min.js": 23846,
	"./prism-parser.js": 94746,
	"./prism-parser.min.js": 15284,
	"./prism-pascal.js": 80413,
	"./prism-pascal.min.js": 99911,
	"./prism-pascaligo.js": 90868,
	"./prism-pascaligo.min.js": 64966,
	"./prism-pcaxis.js": 38561,
	"./prism-pcaxis.min.js": 97155,
	"./prism-peoplecode.js": 62443,
	"./prism-peoplecode.min.js": 42597,
	"./prism-perl.js": 46984,
	"./prism-perl.min.js": 11906,
	"./prism-php-extras.js": 18377,
	"./prism-php-extras.min.js": 80331,
	"./prism-php.js": 6925,
	"./prism-php.min.js": 76311,
	"./prism-phpdoc.js": 37123,
	"./prism-phpdoc.min.js": 60669,
	"./prism-plant-uml.js": 96507,
	"./prism-plant-uml.min.js": 41141,
	"./prism-plsql.js": 68993,
	"./prism-plsql.min.js": 84995,
	"./prism-powerquery.js": 80766,
	"./prism-powerquery.min.js": 36752,
	"./prism-powershell.js": 54888,
	"./prism-powershell.min.js": 34978,
	"./prism-processing.js": 1974,
	"./prism-processing.min.js": 39240,
	"./prism-prolog.js": 51226,
	"./prism-prolog.min.js": 74420,
	"./prism-promql.js": 7182,
	"./prism-promql.min.js": 82688,
	"./prism-properties.js": 47568,
	"./prism-properties.min.js": 15050,
	"./prism-protobuf.js": 55482,
	"./prism-protobuf.min.js": 55636,
	"./prism-psl.js": 39590,
	"./prism-psl.min.js": 11896,
	"./prism-pug.js": 22417,
	"./prism-pug.min.js": 21952,
	"./prism-puppet.js": 88123,
	"./prism-puppet.min.js": 86933,
	"./prism-pure.js": 61383,
	"./prism-pure.min.js": 72233,
	"./prism-purebasic.js": 10033,
	"./prism-purebasic.min.js": 50611,
	"./prism-purescript.js": 35384,
	"./prism-purescript.min.js": 75154,
	"./prism-python.js": 50895,
	"./prism-python.min.js": 72337,
	"./prism-q.js": 20086,
	"./prism-q.min.js": 77352,
	"./prism-qml.js": 35171,
	"./prism-qml.min.js": 28989,
	"./prism-qore.js": 17040,
	"./prism-qore.min.js": 46154,
	"./prism-qsharp.js": 29356,
	"./prism-qsharp.min.js": 78654,
	"./prism-r.js": 56083,
	"./prism-r.min.js": 8717,
	"./prism-racket.js": 73339,
	"./prism-racket.min.js": 84213,
	"./prism-reason.js": 57189,
	"./prism-reason.min.js": 21519,
	"./prism-regex.js": 81362,
	"./prism-regex.min.js": 18156,
	"./prism-rego.js": 99306,
	"./prism-rego.min.js": 93668,
	"./prism-renpy.js": 56067,
	"./prism-renpy.min.js": 19901,
	"./prism-rescript.js": 76507,
	"./prism-rescript.min.js": 65077,
	"./prism-rest.js": 10515,
	"./prism-rest.min.js": 98125,
	"./prism-rip.js": 81166,
	"./prism-rip.min.js": 31232,
	"./prism-roboconf.js": 26031,
	"./prism-roboconf.min.js": 64785,
	"./prism-robotframework.js": 11705,
	"./prism-robotframework.min.js": 71451,
	"./prism-ruby.js": 77265,
	"./prism-ruby.min.js": 51123,
	"./prism-rust.js": 61923,
	"./prism-rust.min.js": 38013,
	"./prism-sas.js": 26496,
	"./prism-sas.min.js": 56602,
	"./prism-sass.js": 16159,
	"./prism-sass.min.js": 1633,
	"./prism-scala.js": 60431,
	"./prism-scala.min.js": 39569,
	"./prism-scheme.js": 1502,
	"./prism-scheme.min.js": 13904,
	"./prism-scss.js": 61437,
	"./prism-scss.min.js": 94663,
	"./prism-shell-session.js": 77546,
	"./prism-shell-session.min.js": 52836,
	"./prism-smali.js": 69233,
	"./prism-smali.min.js": 56723,
	"./prism-smalltalk.js": 79812,
	"./prism-smalltalk.min.js": 53174,
	"./prism-smarty.js": 64913,
	"./prism-smarty.min.js": 95571,
	"./prism-sml.js": 3241,
	"./prism-sml.min.js": 66059,
	"./prism-solidity.js": 69172,
	"./prism-solidity.min.js": 37926,
	"./prism-solution-file.js": 93057,
	"./prism-solution-file.min.js": 14019,
	"./prism-soy.js": 31320,
	"./prism-soy.min.js": 70706,
	"./prism-sparql.js": 44652,
	"./prism-sparql.min.js": 97854,
	"./prism-splunk-spl.js": 64182,
	"./prism-splunk-spl.min.js": 1851,
	"./prism-sqf.js": 55859,
	"./prism-sqf.min.js": 8237,
	"./prism-sql.js": 65437,
	"./prism-sql.min.js": 46407,
	"./prism-squirrel.js": 70586,
	"./prism-squirrel.min.js": 55156,
	"./prism-stan.js": 5301,
	"./prism-stan.min.js": 37887,
	"./prism-stata.js": 88388,
	"./prism-stata.min.js": 75702,
	"./prism-stylus.js": 86135,
	"./prism-stylus.min.js": 32761,
	"./prism-supercollider.js": 44478,
	"./prism-supercollider.min.js": 71056,
	"./prism-swift.js": 22002,
	"./prism-swift.min.js": 47916,
	"./prism-systemd.js": 43282,
	"./prism-systemd.min.js": 30220,
	"./prism-t4-cs.js": 32804,
	"./prism-t4-cs.min.js": 20982,
	"./prism-t4-templating.js": 97135,
	"./prism-t4-templating.min.js": 41361,
	"./prism-t4-vb.js": 89222,
	"./prism-t4-vb.min.js": 80696,
	"./prism-tap.js": 48020,
	"./prism-tap.min.js": 66726,
	"./prism-tcl.js": 19634,
	"./prism-tcl.min.js": 28396,
	"./prism-textile.js": 65388,
	"./prism-textile.min.js": 30110,
	"./prism-toml.js": 89573,
	"./prism-toml.min.js": 87631,
	"./prism-tremor.js": 21908,
	"./prism-tremor.min.js": 13094,
	"./prism-tsx.js": 10558,
	"./prism-tsx.min.js": 71344,
	"./prism-tt2.js": 98259,
	"./prism-tt2.min.js": 32109,
	"./prism-turtle.js": 87083,
	"./prism-turtle.min.js": 62533,
	"./prism-twig.js": 47872,
	"./prism-twig.min.js": 16634,
	"./prism-typescript.js": 45686,
	"./prism-typescript.min.js": 93256,
	"./prism-typoscript.js": 11920,
	"./prism-typoscript.min.js": 97578,
	"./prism-unrealscript.js": 32773,
	"./prism-unrealscript.min.js": 68271,
	"./prism-uorazor.js": 39781,
	"./prism-uorazor.min.js": 53999,
	"./prism-uri.js": 93935,
	"./prism-uri.min.js": 20785,
	"./prism-v.js": 36599,
	"./prism-v.min.js": 86457,
	"./prism-vala.js": 63027,
	"./prism-vala.min.js": 87597,
	"./prism-vbnet.js": 87554,
	"./prism-vbnet.min.js": 35804,
	"./prism-velocity.js": 60262,
	"./prism-velocity.min.js": 60184,
	"./prism-verilog.js": 25783,
	"./prism-verilog.min.js": 53529,
	"./prism-vhdl.js": 9175,
	"./prism-vhdl.min.js": 53081,
	"./prism-vim.js": 38565,
	"./prism-vim.min.js": 26095,
	"./prism-visual-basic.js": 30678,
	"./prism-visual-basic.min.js": 40264,
	"./prism-warpscript.js": 64324,
	"./prism-warpscript.min.js": 99574,
	"./prism-wasm.js": 46425,
	"./prism-wasm.min.js": 66267,
	"./prism-web-idl.js": 72701,
	"./prism-web-idl.min.js": 52775,
	"./prism-wgsl.js": 35192,
	"./prism-wgsl.min.js": 75634,
	"./prism-wiki.js": 7093,
	"./prism-wiki.min.js": 40863,
	"./prism-wolfram.js": 18413,
	"./prism-wolfram.min.js": 13495,
	"./prism-wren.js": 50139,
	"./prism-wren.min.js": 13109,
	"./prism-xeora.js": 94084,
	"./prism-xeora.min.js": 15062,
	"./prism-xml-doc.js": 55051,
	"./prism-xml-doc.min.js": 8165,
	"./prism-xojo.js": 33383,
	"./prism-xojo.min.js": 57321,
	"./prism-xquery.js": 85817,
	"./prism-xquery.min.js": 88891,
	"./prism-yaml.js": 21230,
	"./prism-yaml.min.js": 15520,
	"./prism-yang.js": 57880,
	"./prism-yang.min.js": 79314,
	"./prism-zig.js": 59396,
	"./prism-zig.min.js": 98073
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27586;